/**
 * Signup (Lead) Hooks
 *
 * Provides hooks for lead list and detail operations using createResourceHooks.
 */

import { createResourceHooks } from "./createResourceHooks"
import { createQueryKeys } from "@/lib/queryKeys"
import type { RAListParams } from "@/lib/raClient"
import type { Lead, LeadListFilters } from "@/types/signup"

// ============================================================================
// Query Keys
// ============================================================================

export const leadKeys = createQueryKeys("leads")

// ============================================================================
// Base CRUD Hooks (via createResourceHooks)
// ============================================================================

const leadHooks = createResourceHooks<Lead>("leads", leadKeys)

// ============================================================================
// Exported Hooks
// ============================================================================

export const useLeadsList = (
  params?: RAListParams & { filters?: LeadListFilters },
  options?: { enabled?: boolean; staleTime?: number }
) => {
  const filter: Record<string, unknown> = { ...params?.filter }
  if (params?.filters?.q) {
    filter.q = params.filters.q
  }
  if (params?.filters?.status) {
    filter.status = params.filters.status
  }

  return leadHooks.useList(
    {
      page: params?.page,
      perPage: params?.perPage,
      sort: params?.sort ?? { field: "created_at", order: "DESC" },
      filter,
    },
    options
  )
}

export const useLead = leadHooks.useOne

export const useDeleteLead = leadHooks.useDelete
